import _ from 'lodash';

const customerName = (state) => (customer)=>{
  return (customer.usual_name!=null && customer.usual_name!='')?customer.usual_name:customer.name;
};

const getPrincipalContactName = (state) => (customer) => {
  const primaryContacts = _.filter(_.get(customer, 'company.contacts'), contact => contact.indPrimary === true  && contact.active === true);
  const contact=  _.head(primaryContacts);
  if (contact != null) {
    return `${contact.firstName} ${contact.lastName}`;
  } 
  return '';
 
}

const isFiltered = (state) =>{
  return !(state.filters.active == true &&
          state.filters.checkedCustomerTypes.length==0 &&
          state.filters.checkedCustomerClasses.length==0 &&
          state.filters.checkedTags.length==0 &&
          state.search==='' &&
          state.filters.checkedReps.length==0 &&
          state.filters.checkedTerritories.length==0 &&
          state.filters.withoutTerritories==false &&
          state.filters.withoutReps==false)

}



export default {
  customerName,
  getPrincipalContactName,
  isFiltered,
};
